<div class="map-box relative overflow-hidden top-2 left-2">
  <jb-google-map class="absolute mb-2 w-full h-full rounded-3xl" (init)="init()"></jb-google-map>
  <ul *ngIf="offer.remote && offer.remote !== 'none'" class="m-0  work-type-box list-none flex items-center absolute top-0 right-0 bg-white">
    <li>
      <p  *ngIf="offer.remote == 'full'" >{{ 'jobboard::index.remote_type.full' | translate }}</p>
      <p  *ngIf="offer.remote == 'partial'" >{{ 'jobboard::index.remote_type.partial' | translate }}</p>
    </li>
  </ul>
</div>
